<template>
  <div>
    <headerNotice routerName="选择经营商品"></headerNotice>
    <!-- 发货表格 -->
    <div class="dataTable" v-loading="loading">
      <el-table
        :data="storeList"
        style="width: 100%"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <!-- <el-table-column align="center" label="规格图" width="120">
                    <template slot-scope="scope">
                        <img :src="baseUrl+scope.row.imgUrl" alt width="100" height="100">
                    </template>
                </el-table-column> -->
        <el-table-column
          align="center"
          prop="title"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="propName"
          label="规格名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="propCode"
          label="规格编号"
        ></el-table-column>
    
                 <el-table-column align="center" width="150" label="代发商户">
                    <template slot-scope="scope">
                    
                        <el-select v-model="scope.row.storeUserID" placeholder="全部">
                                <el-option
                                    v-for="item in userList"
                                    :key="item.userID"
                                    :label="item.realName"
                                    :value="item.userID"
                                ></el-option>
                            </el-select>
                    </template>
                </el-table-column>
        <el-table-column align="center" label="是否中心仓商品：" >
             <template slot-scope="scope">
                        <el-switch
                        :disabled="iscenterflat!=1"
                            v-model="scope.row.isCenterItem"
                            :active-value="1"
                            :inactive-value="0"
                            active-text="是"
                            inactive-text="否"
                        ></el-switch>
                    </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="stock"
          label="库存"
          width="100"
          sortable
        ></el-table-column>
        <el-table-column align="center" label="虚拟库存" width="120">
          <template slot-scope="scope">
            <el-input   v-model="scope.row.virtualInventory" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="价格" width="120">
          <template slot-scope="scope">
            <el-input   v-model="scope.row.price" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="虚拟售价" width="120">
          <template slot-scope="scope">
            <el-input   v-model="scope.row.virtualPrice" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="虚拟销量" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.virtualStock" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="排序" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.sort" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否一键同步到分仓：" >
             <template slot-scope="scope">
                        <el-switch
                        :disabled="iscenterflat!=1||scope.row.isCenterItem==0"
                            v-model="scope.row.synchronization"
                            :active-value="1"
                            :inactive-value="0"
                            active-text="是"
                            inactive-text="否"
                        ></el-switch>
                    </template>
        </el-table-column>
      </el-table>
      <!-- 多选操作 -->
      <div style="margin-top: 20px; text-align: center">
        <el-button type="info" @click="cancel">返回</el-button>
        <el-button type="primary" :loading="btnLoading" @click="deliverConfirm"
          >确定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      addItemForm: [],
      orderIDArr: [],
      orderList: [],
      houseList: [],
      loading: false,
      btnLoading: false,
      houseIndex: 0,
      iscenterflat:0,
      userList: [],//商户列表
      storeList: [], //详情数据
      url:
        this.$store.state.apiUrl +
        "/api/services/app/AdminItem/postItemPropList",
    };
  },
  components: {
    headerNotice,
  },
  mounted() {
    if (sessionStorage.getItem("itemmanagin")) {
      if (localStorage.getItem("yth_divisionID") == 0) {
        this.url =
          this.$store.state.apiUrl +
          "/api/services/app/AdminItem/AdminItemPostItemPropList";
      }
     this.iscenterflat=localStorage.getItem("yth_isCenter");
      this.getDatas();
      this.getSelectData();
      this.getDivisionID();
    }
  },
  methods: {
    //获取列表数据
    getDatas() {
      let self = this;
      self.loading = true;
      this.itemIDs = sessionStorage.getItem("itemmanagin");
      this.itemIDs = this.itemIDs.split(",");

      $http.POST({
        url: self.url,
        data: {
          itemIDs: this.itemIDs,
        },
        success(res) {
          self.storeList = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        },
      });
    },
    //获取下拉数据
    getSelectData() {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/GetAllWareHouse?IsCenter=1&FatherHouseID=0",
        success(res) {
          self.houseList = res;
        },
        fail(res) {},
      });
    },
    //取消
    cancel() {
      this.$router.back();
    },
 //获取商户列表
        getDivisionID() {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Division/GetAllMemberInfo",
                params: {},
                success(res) {
                    self.userList = res;
                    console.log( self.userList[0].userID)

                },
                fail(res) {
                }
            })
        },
    //确认
    deliverConfirm() {
      let posturl =
        this.$store.state.apiUrl +
        "/api/services/app/HouseitemAssService/Create";
      if (localStorage.getItem("yth_divisionID") == 0) {
        posturl =
          this.$store.state.apiUrl +
          "/api/services/app/HouseitemAssService/BatchCreate";
      }
      let self = this;
      try {
                self.storeList.forEach(element => {
                
              if ( (number(element.virtualInventory)+element.stock)<0)
              {
                self.$message({
                        message: '库存+虚拟库存不能小于0！',
                        type: 'error'
                    });
                    throw new Error("false")
              }
            });
            } catch (e) {
                if(e.message == 'false'){
                return
                }
            }
      $http.POST({
        url: posturl,
        data: {
          houseitemAssList: self.storeList,
        },
        success(res) {
          self.$message({
            message: "添加成功！",
            type: "success",
          });
          self.$router.push({
            path: "/managing",
          });
        },
        fail(res) {
          self.btnLoading = false;
        },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.dataTable {
  margin: 20px 40px;
  .tableBox {
    border: 1px solid #c5c5c5;
  }
}
</style>